import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CategoryDropdown from "./CategoryDropdown";
import LocationAutocomplete from "./LocationAutocomplete";
import { setSearchParams, fetchSearchResults } from "../store/slices/searchSlice";

const SearchBar = ({ isGoogleLoaded }) => {
  const [locationQuery, setLocationQuery] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { query, categoryId, categoryName,filtre, lat, lng, cityName, saisie } = useSelector((state) => state.search);

  const handleLocationSelect = (place) => {
    setLocationQuery(place?.description);
    dispatch(setSearchParams({ location: place?.description, cityName: place?.description }));
  
    if (isGoogleLoaded && window.google && window.google.maps) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ placeId: place?.place_id }, (results, status) => {
        if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
          const { lat: googleLat, lng: googleLng } = results[0].geometry.location;
          dispatch(setSearchParams({ lat: googleLat(), lng: googleLng() }));
        } else {
          // console.error("Geocoding failed:", place.description);
        }
      });
    }
  };

  const handleCategoryChange = (searchData) => {
    dispatch(setSearchParams(searchData));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const searchParams = {
      query: query || "",
      categoryId: categoryId || null,
      categoryName: categoryName || "",
      location: locationQuery || cityName || "",
      lat: lat || null,
      lng: lng || null,
      cityName: cityName || locationQuery || "",
      sortBy: "relevance",
      filtre:filtre
    };
    dispatch(fetchSearchResults(searchParams));
    navigate("/resultats", { replace: true });
  };

  return (
    <div className="search-bar">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="twyny-group">
          <label htmlFor="search-query">Que recherchez-vous ?</label>
          <CategoryDropdown onChange={handleCategoryChange} />
        </div>
        <div className="seperator"></div>
        <div className="twyny-group">
          <label htmlFor="location-query">Où ?</label>
          <LocationAutocomplete
            onLocationSelect={handleLocationSelect}
            isGoogleLoaded={isGoogleLoaded}
          />
        </div>

        <button 
        type="submit" 
        className="btn twyny-cta-primary mr-16" 
        // disabled={saisie} 
        title={saisie ? 'Veuiller selectionner une catégorie' : ''}>
          Rechercher
        </button>
      </form>
    </div>
  );
};

export default SearchBar;